import * as React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import IconButton from '@mui/material/IconButton';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { styled } from '@mui/material/styles';

const StyledIconArrowButton = styled(IconButton)(({ theme }) => ({
    display: 'inline-block',
    position: 'absolute',
    top: '50%',
    zIndex: 100,
    backgroundColor: '#A5B5AF',
    '&:hover': { backgroundColor: '#DDE3E2' },
    [theme.breakpoints.down('md')]: {
        display: 'none'
    }
}));

const StyledFullscreenButton = styled(IconButton)(({ theme }) => ({
    display: 'inline-block',
    position: 'absolute',
    top: '95%',
    zIndex: 100,
    [theme.breakpoints.down('md')]: {
        display: 'none'
    },
    [theme.breakpoints.up('md')]: {
        position: 'absolute',
        top: 'calc(85vh - 45px)',
        right: 'calc(50% - 50px)',
    }
}));

const StyledPlayButton = styled(IconButton)(({ theme }) => ({
    display: 'inline-block',
    position: 'absolute',
    top: '95%',
    zIndex: 100,
    [theme.breakpoints.down('md')]: {
        backgroundColor: '#f5f5f5c7',
        position: 'absolute',
        left: 'calc(50% - 21px)',
        top: 'calc(50% - 21px)'
    },
    [theme.breakpoints.up('md')]: {
        position: 'absolute',
        top: 'calc(85vh - 45px)',
        left: 'calc(50% - 50px)'
    }
}));

const StyledPauseButton = styled(IconButton)(({ theme }) => ({
    display: 'inline-block',
    position: 'absolute',
    top: '95%',
    zIndex: 100,
    [theme.breakpoints.down('md')]: {
        backgroundColor: '#f5f5f5c7',
        position: 'absolute',
        left: 'calc(50% - 21px)',
        top: 'calc(50% - 21px)',
        animation: 'fadeIn 2200ms',
        animationFillMode: 'forwards',
        '@keyframes fadeIn': {
            '0%': {
                opacity: 1
            },

            '100%': {
                opacity: 0
            }
        }
    },
    [theme.breakpoints.up('md')]: {
        position: 'absolute',
        top: 'calc(85vh - 45px)',
        left: 'calc(50% - 50px)'
    }
}));

const greenIconStyle = {
    height: '30px', width: 'auto', color: '#A5B5AF'
};

const whiteIconStyle = {
    height: '30px', width: 'auto', color: 'white'
};

export const CustomRightNav = ({ onClick, disabled }) => {
    return (
        <StyledIconArrowButton
            aria-label="right nav button"
            onClick={onClick}
            disabled={disabled}
            sx={{
                right: '2%'
            }}
        >
            <ChevronRightIcon sx={whiteIconStyle} />
        </StyledIconArrowButton>
    );
};

export const CustomLeftNav = ({ onClick, disabled }) => {
    return (
        <StyledIconArrowButton
            aria-label="leftNavButton"
            onClick={onClick}
            disabled={disabled}
            sx={{
                left: '2%'
            }}
        >
            <ChevronLeftIcon sx={whiteIconStyle} />
        </StyledIconArrowButton>
    );
};

export const CustomFullscreen = ({ onClick, isFullscreen, setFullscreen }) => {
    return !isFullscreen ? (
        <StyledFullscreenButton
            className='custom-fullscreen-btn'
            aria-label="enterFullscreenButton"
            onClick={() => {
                setFullscreen(true);
                onClick();
            }}
        >
            <FullscreenIcon sx={greenIconStyle} />
        </StyledFullscreenButton>
    ) : (
        <StyledFullscreenButton
            className='custom-fullscreen-btn'
            aria-label="exitFullscreenButton"
            onClick={() => {
                setFullscreen(false);
                onClick();
            }}
        >
            <FullscreenExitIcon sx={greenIconStyle} />
        </StyledFullscreenButton>
    );
};

export const CustomPlayPause = ({ onClick, isPlaying, setPlay, showPlayBtn, mobileScreen }) => {
    return !isPlaying ? (
        <StyledPlayButton
            className='custom-play-btn'
            sx={{
                display: !showPlayBtn && mobileScreen && 'none'
            }}
            aria-label="playButton"
            onClick={() => {
                setPlay(true);
                onClick();
            }}
        >
            <PlayArrowIcon sx={greenIconStyle} />
        </StyledPlayButton>
    ) : (
        <StyledPauseButton
            className='custom-pause-btn'
            aria-label="pauseButton"
            onClick={() => {
                setPlay(false);
                onClick();
            }}
        >
            <PauseIcon sx={greenIconStyle} />
        </StyledPauseButton>
    );
};
